<template>
    <div class="sa-tab-scroll">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <b-row>
                <b-card class="sa-card sa-card-border" header="Dettaglio Farmaco" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Nome Farmaco</label>
                            <span>{{ jsonData.descrizione }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Principio Attivo</label>
                            <span>{{ jsonData.principioAttivoFarmaco.descrizione }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Forma Farmaceutica</label>
                            <span>{{ jsonData.formaFarmaceutica.descrizione }} </span>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Data prezzo</label>
                            <span>{{ formatDate(jsonData.dataPrezzo1) }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Prezzo </label>
                            <span>{{ jsonData.euroPrezzo1 }}€</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Classe Farmaco</label>
                            <span>{{ jsonData.classe1 }} / {{ jsonData.classe2 }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Ricetta</label>
                            <span>{{ jsonData.tipoRicetta1 }} / {{ jsonData.tipoRicetta2 }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Mesi Scadenza</label>
                            <span>{{ jsonData.mesiScadenza }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Gruppo Terapeutici</label>
                            <span>{{ jsonData.gruppoTerapeuticiBean.descrizione }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Regimi SSN</label>
                            <span>{{ jsonData.regimeSsn1Bean.descrizioneSintetica }} / {{ jsonData.regimeSsn2Bean.descrizioneSintetica }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Classificazione ATC</label>
                            <span>{{ jsonData.atcClassificazione.descrizione }} ({{ jsonData.atcClassificazione.codiceElemento }}) </span>
                        </b-col>
                        <b-col v-if="jsonData.farmacoPrescrivibilita.descrizioneSintetica !== null" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Prescrivibilità</label>
                            <span>{{ jsonData.farmacoPrescrivibilita.descrizioneSintetica }} </span>
                        </b-col>
                        <!-- <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Regime SSN Due</label>
                            <span>{{ jsonData.regimeSsn2Bean.descrizioneSintetica }} </span>
                        </b-col> -->
                    </b-row>
                </b-card>
            </b-row>
            <b-row>
                <b-card class="sa-card sa-card-border" header="Tipo Prodotto" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Descrizione Prodotto</label>
                            <span>{{ jsonData.tipoProdottoBean.descrizioneSintetica }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Elemento</label>
                            <span>{{ jsonData.tipoProdottoBean.tipoElemento }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Elemento Attivo</label>
                            <span>{{ jsonData.tipoProdottoBean.elementoAttivo }} </span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-row>
            <b-row>
                <b-card class="sa-card sa-card-border" header="Ditta Produzione" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Ragione Sociale</label>
                            <span>{{ jsonData.ditta.ragioneSociale }} ({{ jsonData.ditta.codiceDitta }}) </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale</label>
                            <span>{{ jsonData.ditta.codiceFiscale }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Provincia</label>
                            <span>{{ jsonData.ditta.provincia1 }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Città</label>
                            <span>{{ jsonData.ditta.citta1 }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Telefono</label>
                            <span>{{ jsonData.ditta.telefono1 }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Email</label>
                            <span>{{ jsonData.ditta.email1 }} </span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-row>
            <b-row>
                <b-card v-if="itemsMonografia.length > 0" class="sa-card sa-card-border" header="Monografia" header-tag="header" footer-tag="footer" title="">
                    <b-card v-for="(sezione, index) in itemsMonografia" :key="index" class="sa-card sa-card-border" :header="sezione.sezione" header-tag="header" footer-tag="footer" title="">
                        <span>{{ sezione.testo }}</span>
                    </b-card>
                </b-card>
            </b-row>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    // props: { id: { type: String } },
    data() {
        return {
            pathResource: "/farmaci",
            showModalLoading: false,
            listKey: 0,
            rows: 0,
            perPage: 50,
            currentPage: 1,
            id: null,
            // id: "987417666",
            jsonData: { ditta: {}, atcClassificazione: {}, formaFarmaceutica: {}, farmacoPrescrivibilita: {}, principioAttivoFarmaco: {}, gruppoTerapeuticiBean: {}, tipoProdottoBean: {}, regimeSsn1Bean: {}, regimeSsn2Bean: {}, listaMonografia: [] },
            sezioniMonografia: null,
            itemsMonografia: [],
        };
    },
    mounted() {},
    watch: {},
    methods: {
        init(id) {
            let me = this;
            me.id = id;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.id, {}, me.resultResponseLoaData, me.resulErrorLoadData);
        },
        resultResponseLoaData(response) {
            let me = this;
            me.jsonData = response.data.data;
            if (me.jsonData.listaMonografia.length > 0) {
                me.buildMonografia(me.jsonData.listaMonografia);
            }
        },
        resulErrorLoadData(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        buildMonografia(array) {
            let me = this;
            me.sezioniMonografia = {};
            me.itemsMonografia = [];
            array.forEach((element) => {
                if (!me.sezioniMonografia[element.descrizioneSezione]) {
                    me.sezioniMonografia[element.descrizioneSezione] = { sezione: element.descrizioneSezione, testo: "" };
                }
                me.sezioniMonografia[element.descrizioneSezione].testo += element.testo + " ";
            });
            me.itemsMonografia = Object.values(me.sezioniMonografia);
        },
    },
};
</script>
